/** Letters only — strip spaces, numbers, and special characters. */
export function sanitizePassengerName(value = "") {
  return String(value || "")
    .replace(/\s+/g, "")
    .replace(/[^a-zA-Z]/g, "");
}

/**
 * Keep firstName and middleName separate.
 * If middle was lumped into firstName, peel it into middleName.
 * Sanitize both (no spaces / numbers / special chars).
 */
export function splitGivenNames(firstName = "", middleName = "") {
  let middle = String(middleName || "").trim();
  let first = String(firstName || "").trim();

  if (middle && first) {
    const escaped = middle.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const suffix = new RegExp(`(?:\\s+|-)?${escaped}$`, "i");
    if (suffix.test(first) && first.length > middle.length) {
      first = first.replace(suffix, "").trim();
    }
  }

  const parts = first.split(/\s+/).filter(Boolean);
  if (parts.length > 1) {
    first = parts[0];
    if (!middle) middle = parts.slice(1).join("");
  } else {
    first = parts[0] || "";
  }

  return {
    firstName: sanitizePassengerName(first),
    middleName: sanitizePassengerName(middle),
  };
}

/** Normalize traveler name fields for UI state or API payload. */
export function normalizePassengerNames(passenger = {}) {
  const { firstName, middleName } = splitGivenNames(
    passenger?.firstName,
    passenger?.middleName,
  );
  const lastName = sanitizePassengerName(passenger?.lastName);

  const next = {
    ...passenger,
    firstName,
    lastName,
  };

  if (middleName) next.middleName = middleName;
  else delete next.middleName;

  return next;
}
